export const CREATE_ACCOUNT_ENDPOINT = '/login/createAccount';
export const CREATE_ACCOUNT_ESCROW_ENDPOINT = '/piui/get-create-account-props';
export const SECURITY_QUESTION_ESCROW_ENDPOINT = '/piui/get-security-questions-escrow';
export const CHECK_EMAIL_AVAILABILITY_ENDPOINT = '/login/checkEmailAvailability';
export const CHECK_USERNAME_AVAILABILITY_ENDPOINT = '/login/checkUsernameAvailability';
export const GET_INSTITUTIONS_ENDPOINT = '/login/institutions/';
